import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadModalComponent } from './upload-modal/upload-modal.component';
import { MatTabsModule } from '@angular/material/tabs';
import {
  MatDialogModule,
  MatButtonModule,
  MatListModule,
  MatProgressBarModule
} from '@angular/material';

import { IcsDriveService } from './ics-drive.service';
import { ImagePopupComponent } from './image-popup/image-popup.component';
/**
 * Root module for Ics Drive. Has to be imported in application module files.
 */
@NgModule({
  imports: [
    CommonModule,
    MatTabsModule,
    MatDialogModule,
    MatButtonModule,
    MatListModule,
    MatProgressBarModule
  ],
  declarations: [UploadModalComponent, ImagePopupComponent],
  exports: [MatTabsModule, UploadModalComponent, ImagePopupComponent],
  entryComponents: [UploadModalComponent]
})
export class IcsDriveModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: IcsDriveModule,
      providers: [
        IcsDriveService
      ]
    };
  }
}
